import _ from "lodash"
import { FormQuestion, QuestionTypes } from "sharedTypes"

export const NO_RESPONSE_LABEL = "No Response"

// Base for a choice's percentage: every response, so multiple-answer shares are per person.
export const responseTotal = ({ responses }: FormQuestion) => _.sum(Object.values(responses ?? {}))

type ResponseSlice = { name: string, value: number }

// Multiple-answer responses are keyed by a JSON array of the picked choices.
export const barResponseSummary = ({ responses }: FormQuestion): ResponseSlice[] => Object.entries(
  Object.entries(responses).reduce((acc, [rawResponse, value]) => {
    let responseSet: string[] = []
    try {
      responseSet = JSON.parse(rawResponse)
    } catch (error) {
      responseSet = [rawResponse]
    }

    if (responseSet.length === 0) {
      acc[NO_RESPONSE_LABEL] = value
    }

    responseSet.forEach((response) => {
      if (acc[response]) {
        acc[response] += value
      } else {
        acc[response] = value
      }
    })

    return acc
  }, {} as Record<string, number>),
)
  .map(([name, value]) => ({ name, value }))
  .sort((a, b) => b.value - a.value)

export const pieResponseSummary = ({ responses }: FormQuestion): ResponseSlice[] => (
  Object.entries(responses).map(([name, value]) => ({ name, value }))
)

// The slices the Submissions > Questions charts show, in their order; a slice's
// index picks its colour from CHART_COLORS.
export const responseSlices = (question: FormQuestion): ResponseSlice[] => {
  if (!Object.keys(question.responses ?? {}).length) {
    return (question.choices ?? []).map((choice) => ({ name: choice, value: 0 }))
  }

  // Same split as Submissions/ResponseChart/Chart.tsx.
  const bar = [QuestionTypes.MultipleAnswer, QuestionTypes.Terms].includes(question.type)

  return bar ? barResponseSummary(question) : pieResponseSummary(question)
}
